import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { TableEffects } from "./ngrx/table.effects";
import * as tableReducers from "./ngrx/table.reducers";
import { TableFacadeService } from "./services/table-facade.service";
import { TableHttpService } from "./services/table-http.service";

@NgModule({
  declarations: [],
  providers: [
    TableHttpService,
    TableFacadeService,
  ],
  imports: [
    CommonModule,
    StoreModule.forFeature("table", tableReducers.reducer),
    EffectsModule.forFeature([TableEffects]),
  ],
  exports: [],
})
export class TableModule {}
